<!-- =========================================================================================
  File Name: InviteStudentSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isStudentSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} STUDENT</h4>
        <feather-icon icon="XIcon" @click.stop="isStudentSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

       <div class="p-6">
            <!-- Product Image -->
        <template >

          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataImg"  class="responsive">
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Update Image</vs-button>
            <vs-button type="flat" color="#999" @click="dataImg = null">Remove Image</vs-button>
          </div>
        </template>


        <!-- NAME -->
        <vs-input label="Name" v-model="dataName" class="mt-5 w-full" name="item-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>
         <!-- NICk Name -->
        <vs-input label="Nick Name" v-model="dataNick" class="mt-5 w-full" name="item-nickname" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-nickname')">{{ errors.first('item-nickname') }}</span>

        <!-- CATEGORY -->
        <vs-select v-model="dataProgram" label="Program" class="mt-5 w-full" name="item-category" autocomplete v-validate="'required'">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in category_choices" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-category')">{{ errors.first('item-category') }}</span>

        <!-- ORDER STATUS -->
        <vs-select v-model="dataCamUser" label="Cam User" class="mt-5 w-full" autocomplete>
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in order_status_choices" />
        </vs-select>

        <!-- ORDER STATUS -->
<!--        <vs-select v-model="dataRoom" label="Rooms" class="mt-5 w-full">-->
<!--          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in rooms_choices" :multi="true" />-->
<!--        </vs-select>-->
        <br>
        <label class="vs-select--label w-full">Cameras</label>
        <v-select  label="Rooms"  multiple :closeOnSelect="false" v-model="selected" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isStudentSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'


export default {
  props: {
    isStudentSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      dataId: null,
      dataName: null,
      dataFirstName: null,
      dataLastName: null,
      dataNick: null,
      dataImg: null,
      dataProgram: '',
      dataCamUser: '',
      dataRoom: null,
      camusers: [
        {
          id:'1',
          name:'Williuam John',
          avatar: require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          email:'will@xyz.com',
          phone:'(601)-555-111',
          student:'',
          status:'',
          econtact:'Yes'
        },
        {
          id:'2',
          name:'Brain Carry',
          avatar: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          email:'will@xyz.com',
          phone:'(601)-555-111',
          student:'',
          status:'',
          econtact:'No'
        },
          {
          id:'3',
          name:'John Brain',
          avatar: require('@/assets/images/portrait/small/avatar-s-3.jpg'),
          email:'will@xyz.com',
          phone:'(601)-555-111',
          student:'',
          status:'',
          econtact:'Yes'
        },
          {
          id:'4',
          name:'Carry Williuam',
          avatar: require('@/assets/images/portrait/small/avatar-s-4.jpg'),
          email:'will@xyz.com',
          phone:'(601)-555-111',
          student:'',
          status:'',
          econtact:'No'
        },
      ],
      category_choices: [
        {text:'Photography', value:'Photography'},
        {text:'Art', value:'Art'},
        {text:'Dancing', value:'Dancing'},
        {text:'Gym', value:'Gym'}
      ],
       order_status_choices: [
        {text:'Adams Baker', value:'Adams Baker'},
        {text:'Clark Davis', value:'Clark Davis'},
        {text:'Evans Frank', value:'Evans Frank'},
        {text:'Ghosh Hills', value:'Ghosh Hills'}
      ],
      selected: ['Room 1','Room 3'],
      options: ['Room 4','Room 5','Room 6'],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isStudentSidebarActive (val) {
      console.log(this.data)
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.initValues()
      }
    }
  },
  computed: {
    isStudentSidebarActiveLocal: {
      get () {
        return this.isStudentSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeStudentSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataName && this.dataNick && this.dataProgram
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataFirstName = null
      this.dataLastName = null
      this.dataNickName = null
      this.dataEmail = null
      this.dataPhone = null
      this.dataIsEmergencyContact = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            student_id: this.dataId,
            first_name: this.dataFirstName,
            last_name: this.dataLastName,
            email: this.dataEmail,
            phone: this.dataPhone
          }

          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('dataList/updateStudent', obj).catch(err => { console.error(err) })
          } else {
            delete obj.id
            obj.popularity = 0
            this.$store.dispatch('dataList/addStudent', obj).catch(err => { console.error(err) })
          }

          this.$emit('closeStudentSidebar')
          this.initValues()
        }
      })
    },
        updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
